module.exports = __webpack_public_path__ + "img/business_chat.33991e75.svg";